import { required, length, email } from "../../utils/validators";
import Auth from "./auth";
import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import Input from "../../components/form/input/input";

function Signin(props) {
  const [state, setState] = useState({
    loginForm: {
      email: {
        value: "",
        isValid: false,
        touched: false,
        message: "please enter a valid email",
        validators: [required, email],
        required: true,
      },
      password: {
        value: "",
        isValid: false,
        touched: false,
        message: "Password must be at least 8 characters",
        required: true,
        validators: [required, length({ min: 8 })],
      },
    },
    formIsValid: false,
  });

  const navigate = useNavigate();
  const submitHandler = async (e) => {
    e.preventDefault();
    const email = state.loginForm.email;
    const password = state.loginForm.password;
    // let emailIsValid = true;

    // for (const validator of email.validators) {
    //   emailIsValid = emailIsValid && validator(email.value);
    // }

    // let passwordIsValid = true;

    // for (const validator of password.validators) {
    //   passwordIsValid = passwordIsValid && validator(password.value);
    // }
    // const formIsValid = emailIsValid || passwordIsValid;

    // if (!formIsValid) {
    //   return setState((prevState) => {
    //     return {
    //       ...prevState,
    //       formIsValid: formIsValid,
    //     };
    //   });
    // }

    const signin = await props.onSignin(e, {
      email: email.value,
      password: password.value,
    });
    if (signin) {
      navigate("/");
    }
  };

  const inputChangeHandler = (input, value) => {
    setState((prevState) => {
      let isValid = true;
      for (const validator of prevState.loginForm[input].validators) {
        isValid = isValid && validator(value);
      }
      const updatedForm = {
        ...prevState.loginForm,
        [input]: {
          ...prevState.loginForm[input],
          isValid: isValid,
          touched: true,

          value: value,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].isValid;
      }
      return {
        loginForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  };

  const inputBlurHandler = (input) => {
    setState((prevState) => {
      return {
        ...prevState,
        loginForm: {
          ...prevState.loginForm,
          [input]: {
            ...prevState.loginForm[input],
            touched: true,
          },
        },
      };
    });
  };

  return (
    <Auth>
      <form
        onSubmit={submitHandler}
        className="h-full  w-96  p-6 dark:bg-slate-700 bg-gray-400 rounded-md"
      >
        {props.errorMessage && (
          <h1 className="text-center text-red-500">{props.errorMessage}</h1>
        )}
        <Input
          id="email"
          label="Email"
          type="email"
          control="input"
          onChange={inputChangeHandler}
          value={state.loginForm["email"].value}
          valid={state.loginForm["email"].isValid}
          message={state.loginForm["email"].message}
          required={state.loginForm["email"].required}
          onBlur={inputBlurHandler}
          touched={state.loginForm["email"].touched}
        />
        <Input
          id="password"
          label="Password"
          type="password"
          control="input"
          onChange={inputChangeHandler}
          value={state.loginForm["password"].value}
          valid={state.loginForm["password"].isValid}
          message={state.loginForm["password"].message}
          required={state.loginForm["password"].required}
          onBlur={inputBlurHandler}
          touched={state.loginForm["password"].touched}
        />
        <button
          className="btn float-right mt-6"
          type="submit"
          disabled={!state.formIsValid}
        >
          Signin
        </button>
        <NavLink
          to="/user/password_reset"
          className="link text-custom-blue font-bold"
        >
          Forgot password?
        </NavLink>
        <div>
          <span>Don't have an account? </span>
          <NavLink
            to="/join/signup"
            className="link text-custom-blue font-bold"
          >
            Signup
          </NavLink>
        </div>
      </form>
    </Auth>
  );
}

export default Signin;
